var map = {
	"./development": 700014,
	"./development.js": 700014,
	"./kubes": 900696,
	"./kubes.js": 900696,
	"./production": 37983,
	"./production.js": 37983,
	"./staging": 655568,
	"./staging.js": 655568,
	"./staging2": 274849,
	"./staging2.js": 274849,
	"./test": 357906,
	"./test.js": 357906
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 338391;